import css from 'styled-jsx/css';

export default css`
  .features-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    cursor: pointer;
  }
  .posts-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition:
      max-height 0.4s ease-in-out,
      opacity 0.4s ease-in-out;
  }
  .posts-list.active {
    opacity: 1;
    height: auto;
    max-height: 10000px;
  }
`;
